import { render, staticRenderFns } from "./EditLanguagesAndSkillsDialog.vue?vue&type=template&id=94d8859e&"
import script from "./EditLanguagesAndSkillsDialog.vue?vue&type=script&lang=js&"
export * from "./EditLanguagesAndSkillsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports